module.exports = __webpack_public_path__ + "static/media/10.d9f74575.svg";